module.exports = __webpack_public_path__ + "img/m-vac.8838bf0b.svg";